import React, { useState } from 'react';
import GroupLogo from '../GroupLogo';
import GroupLogoPickerSheet from './GroupLogoPickerSheet';

/**
 * Clickable org logo — opens picker (upload / link / documents), then persists groups.logo_url.
 */
const GroupLogoUpload = ({
  groupId,
  name,
  logoUrl,
  onUploaded,
  onError,
  disabled = false,
  size = 'sm'
}) => {
  const [open, setOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  const displayUrl = previewUrl || logoUrl;

  const stopRowClick = (e) => {
    e.stopPropagation();
  };

  const openPicker = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setOpen(true);
  };

  return (
    <>
      <button
        type="button"
        className={[
          'group-logo-upload',
          disabled ? 'group-logo-upload--disabled' : ''
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={openPicker}
        onMouseDown={stopRowClick}
        onPointerDown={stopRowClick}
        disabled={disabled}
        aria-label={disabled ? undefined : `Change logo for ${name}`}
        title={disabled ? undefined : 'Change logo'}
      >
        <GroupLogo name={name} logoUrl={displayUrl} size={size} bare />
      </button>

      <GroupLogoPickerSheet
        open={open}
        onClose={() => setOpen(false)}
        groupId={groupId}
        groupName={name}
        currentLogoUrl={logoUrl}
        onSaved={(url) => {
          setPreviewUrl('');
          onUploaded?.(url);
        }}
        onError={onError}
      />
    </>
  );
};

export default GroupLogoUpload;
